import Ajv from 'ajv';
import contractSchema from '@das/canvas-contract-json-schema';

const formatOpts = {
  dataVar: 'contract',
  separator: '\n'
};

/**
 * validate a given contract object and print errors if any
 * @param {object} contract - the contract object to be validated
 * @returns {string} empty string for valid contracts, otherwise a message describing what failed
 */
export default function validateAndPrintErrors(contract = {}) {
  const ajv = new Ajv();
  const validate = ajv.compile(contractSchema);
  const isValid = validate(contract);

  if (isValid) {
    return '';
  }

  // deduplicate lines
  const text = ajv.errorsText(validate.errors, formatOpts);
  const lines = text.split(formatOpts.separator);
  const deduped = Array.from(new Set(lines));

  // log all error messages when dev
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error(deduped.join(formatOpts.separator));
  }

  // only return the error message caused by the deepest property
  return deduped.reduce((acc, cur) => {
    const [deepest] = acc.split(' ');
    const [current] = cur.split(' ');
    return current.length > deepest.length ? cur : acc;
  });
}
